import React from 'react'
import './edu.css'

function Education() {
    return (
        <div className="e">
        <h1>Education qualification</h1>

        <div className="e-detail">
        <div className="ec">
        <h1 className="e-detail-h1">Degree</h1>
        <p className="e-detail-p">B.TECH.</p>
        <p className="e-detail-p">D.C.A.</p>
        <p className="e-detail-p">12th</p>
        <p className="e-detail-p">10th</p>

        
        </div>
        <div className="ec">
        <h1 className="e-detail-h1">University</h1>
        <p className="e-detail-p">UIET M.D.U.</p>
        <p className="e-detail-p">IINT</p>
        <p className="e-detail-p">HBSE</p>
        <p className="e-detail-p">HBSE</p>

        
        </div>
        <div className="ec">
        <h1 className="e-detail-h1">Division </h1>
        <p className="e-detail-p">Ist</p>
        <p className="e-detail-p">Ist</p>
        <p className="e-detail-p">Ist</p>
        <p className="e-detail-p">Ist</p>

        
        </div>



        
        </div>


            
        </div>
    )
}

export default Education
